<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div class="custom-table-container tableContainer">
      <div class="margin-bottom">
        <div class="formContainer">
          <MaterialRequester
            :store="customStoreForm"
            @updateFormData="updateFormData"
          />
        </div>
      </div>

      <div id="materialList">
        <div class="margin-bottom">
          <div class="custom-card-header-material-request">
            <span class="titulo-card-header">{{
              $t('materials_Available')
            }}</span>
          </div>
          <MaterialList :store="customStore" />
        </div>

        <div class="margin-bottom">
          <div class="custom-card-header-material-request">
            <span class="titulo-card-header">{{
              $t('materials_selected')
            }}</span>
          </div>
          <MaterialCart class="margin" :store="materialsSelected" />
        </div>
      </div>
      <div
        class="content-setting display-flex justify-content-flex-start no-margin-top gap"
      >
        <f7-button
          class="botones-registrar"
          style="max-width: 150px"
          fill
          outline
          type="default"
          styling-mode="contained"
          name="ButtonAddMaterials"
          @click="addMaterials"
        >
          {{ $t('material_request') }}
        </f7-button>
        <f7-button
          name="btnGoBack"
          class="color-gray margin-left"
          @click="goToBack"
        >
          {{ $t('cancel') }}
        </f7-button>
      </div>
    </div>
    <acceptRequestPopup
      v-if="acceptRequestPopup"
      @confirmAcceptance="materials"
    />
    <confirmPopUp v-if="confirmPopup" />
  </f7-page>
</template>

<script>
import MaterialRequester from '@/components/MaterialRequest/MaterialRequester/index.vue';
import MaterialList from '@/components/MaterialRequest/MaterialList/MaterialList.vue';
import { mapState, mapActions } from 'vuex';
import MaterialCart from '@/components/MaterialRequest/MaterialCart/MaterialCart.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import acceptRequestPopup from '@/components/MaterialRequest/acceptRequestPopup/index.vue';
import confirmPopUp from '@/components/MaterialRequest/PopUp/confirmPopUp.vue';

export default {
  components: {
    MaterialRequester,
    MaterialList,
    MaterialCart,
    acceptRequestPopup,
    confirmPopUp,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
      customStoreForm: null,
      customStoreCart: null,
    };
  },
  computed: {
    ...mapState('materialRequest', [
      'materials',
      'materialsSelected',
      'acceptRequestPopup',
      'confirmPopup',
    ]),
    ...mapState('Offers', ['presupuestos']),
    ...mapState('user', ['authenticatedUser']),
    ...mapState('user', ['authenticatedUser']),
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      return this.lastRouteHome ? 'Home' : 'MaterialRequest';
    },
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('material_request'),
        disabled: false,
        page: 'MaterialRequest',
        active: false,
      },
      {
        name: this.$t('Request_sampling_material'),
        disabled: true,
        page: 'MaterialRequester',
        active: true,
      },
    ]);
  },
  async mounted() {
    try {
      // this.$f7.preloader.show();
      await this.fetchPresupuestos(3);
      await this.fetchMaterials(this.presupuestos[0].CodPlantaVenta);
      this.customStore = this.materials;
      await this.formatMaterialRequester();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
      // this.$f7.preloader.hide();
    }
  },
  methods: {
    async formatMaterialRequester() {
      const ofertasFiltradas = this.presupuestos.map((oferta) => {
        return {
          ...oferta,
          CodPresupuestoTitulo: `${oferta.CodPresupuesto} - ${oferta.Titulo}`,
        };
      });
      this.customStoreForm = ofertasFiltradas.sort(
        (a, b) =>
          new Date(b.FechaPresupuesto) - new Date(a.FechaPresupuesto)
      );
      return this.customStoreForm;
    },
    updateFormData(newFormData) {
      this.formData = newFormData;
    },
    async addMaterials() {
      if (this.materialsSelected.length === 0) {
        this.$notifyDX(
          {
            message: this.$t('select_at_least_one_material'),
            width: 450,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return;
      }
      const isEmpty = (v) =>
        v === null ||
        v === undefined ||
        (typeof v === 'string' && v.trim() === '');

      const formulario = {
        ...this.formData,
        materialsSelected: this.materialsSelected,
      };

      const codContactoFinal =
        formulario.contactCode ||
        this.authenticatedUser?.contacts?.[0]?.code;

      const codPresupuestoFinal = formulario.CodPresupuesto;
      const codDireccionFinal = formulario.addresses;

      if (
        isEmpty(codContactoFinal) ||
        isEmpty(codPresupuestoFinal) ||
        isEmpty(codDireccionFinal)
      ) {
        this.$notifyDX(
          {
            message:
              this.$t('samplesRegister.missingFieldsError') ||
              'Por favor, completa los campos obligatorios antes de enviar la solicitud.',
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return;
      }
      this.setMaterialsRequest({
        CodPlanta: this.presupuestos[0].CodPlantaVenta,
        Referencia: formulario.Referencia,
        CodCliente: this.presupuestos[0].CodCliente,
        CodDivisa: this.presupuestos[0].CodDivisa,
        CodDireccion: codDireccionFinal,
        TipoEntrega: formulario.deliveryType,
        CodContacto: codContactoFinal,
        Email: formulario.Email || this.authenticatedUser.email,
        CodPresupuesto: codPresupuestoFinal,
        Observaciones: formulario.observations,
        Materiales: formulario.materialsSelected.map((material) => ({
          CodArticulo: material.CodArticulo,
          UnidadMedida: '',
          Cantidad: material.Cantidad,
          Precio: null,
          SeccionesAnalíticas: {
            CCE1: '',
            CCE2: '',
            CCE3: '',
            CCE4: '',
            CCE5: '',
            CCE6: '',
            CCE7: '',
            CCE8: '',
            CCE9: '',
          },
        })),
      });

      this.setAcceptRequestPopup(true);
    },
    goToBack() {
      this.$f7router.navigate(
        { name: this.$f7router.previousRoute.name },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
      this.deleteAllMaterailsSelected();
    },
    ...mapActions('materialRequest', [
      'fetchMaterials',
      'setMaterialsRequest',
      'setMaterialsSelected',
      'setAcceptRequestPopup',
      'deleteAllMaterailsSelected',
    ]),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', ['fetchPresupuestos']),
  },
};
</script>
<style lang="scss" scoped>
@import './materialRequester.styles.scss';
</style>
